import { render } from "./tags-sections-detail.vue?vue&type=template&id=5116a07c"
import script from "./tags-sections-detail.vue?vue&type=script&lang=js"
export * from "./tags-sections-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__